/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "e00672a693e013a080a1e45be4371e5161c75c8b";
